import React from "react";
import clsx from "clsx";
// types
import TLanguageVersionDetail from "@/cms/types/TLanguageVersionDetail";
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";
// utilities
import { metaDataLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";


type TNoData = {

    icon: React.ReactNode;
    className?: string;
    textClassName?: string;
    languageVersions?: TLanguageVersionList[]|TLanguageVersionDetail[]; // siteSettings
    
}

const NoData = ( props:TNoData ) => {

    const noData = metaDataLanguageVersion("noData", props.languageVersions);

    return (
        <div className={clsx("no-data", props.className)}>
            { props.icon }
            <p className={clsx("no-data-content", props.textClassName)}>{ noData }</p>
        </div>
    );

}

export default NoData;
export type {
    TNoData
};